import React, { forwardRef } from 'react';

import { Box } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { makeStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import Typography from '@material-ui/core/Typography';

import ControllerInput from './ControllerInput';

const useStyles = makeStyles(() => ({
  container: {
    borderRadius: 7,
    border: '1px solid #e3e7ef',
    backgroundColor: '#fafbff',
    transition: 'border-color .15s, background-color .15s',

    '&:hover': {
      backgroundColor: '#f2f5ff',
      borderColor: '#c5cff7',
    },
  },

  containerChecked: {
    backgroundColor: '#eef1ff',
    borderColor: '#a5b4fc',
  },

  controlLabel: {
    margin: 0,
    width: '100%',
    justifyContent: 'space-between',
    padding: '4px 6px 4px 10px',
  },

  labelText: {
    fontSize: '0.75rem',
    fontWeight: 500,
    color: '#64748b',
    lineHeight: 1.35,
    userSelect: 'none',
  },

  labelTextChecked: {
    color: '#4a5fa8',
    fontWeight: 600,
  },

  switchBase: {
    '&.Mui-checked': {
      color: '#667eea',
    },
    '&.Mui-checked + .MuiSwitch-track': {
      backgroundColor: '#667eea',
      opacity: 1,
    },
  },

  track: {
    borderRadius: 20,
    backgroundColor: '#c7ced9',
    opacity: 1,
  },
}));

export const SwitchInputBase = forwardRef(
  ({ label, value, helperText, ...rest }, ref) => {
    const classes = useStyles();

    return (
      <Box
        className={`${classes.container} ${
          value ? classes.containerChecked : ''
        }`}
      >
        <FormControlLabel
          labelPlacement="start"
          className={classes.controlLabel}
          control={
            <Switch
              {...rest}
              size="small"
              checked={value}
              inputRef={ref}
              classes={{
                switchBase: classes.switchBase,
                track: classes.track,
              }}
            />
          }
          label={
            <Typography
              className={`${classes.labelText} ${
                value ? classes.labelTextChecked : ''
              }`}
            >
              {label}
            </Typography>
          }
        />
      </Box>
    );
  },
);

function SwitchInput({
  name,
  group = 'default',
  priority = 1,
  visible = true,
  deps = [],
  disabled = false,
  mask,
  identificador,
  ...props
}) {
  return (
    <ControllerInput
      name={name}
      group={group}
      priority={priority}
      deps={deps}
      disabled={disabled}
      visible={visible}
      mask={mask}
      adapterValueOnChange={(e) => e.target.checked}
      render={({ field }) => <SwitchInputBase {...props} {...field} />}
      identificador={identificador}
    />
  );
}

export default SwitchInput;
